import $ from 'jquery';
import * as api from './api';
import { checkReserveStatus } from './reserve';
let canClick = true;
export const conf = [
  'MyCard會員點數1000點',
  'MyCard會員點數300點',
  'MyCard會員點數90點',
  '天機豪禮·壹',
  '天機豪禮·貳',
  '天機豪禮·叁',
  '天機豪禮·肆',
];
const showBagPopup = data => {
  let html = `<tr><td>-</td><td>-</td></tr>`;
  $('.j-bag-body').html('');
  if (data && data.length) {
    html = '';
    data.map(item => {
      if (item.gift_key > 10 || item.gift_key < 4) return;
      html += `<tr>
      <td class="left">${conf[item.gift_key - 4]}</td>
      <td class="right">${item.time}</td>
    </tr>`;
    });
  }
  $('.j-bag-body').html(html);
  $('.j-bag-popup').fadeIn(500);
};

export const show = async () => {
  if (!canClick) return;
  canClick = false;
  let res;
  if (checkReserveStatus()) {
    let bagRes = await api.getBag();
    +bagRes.result > 0 ? (res = bagRes.data) : '';
  }
  showBagPopup(res);
  canClick = true;
};

$('.j-bag').on('click', async function () {
  await show();
});
